import React, { lazy } from 'react';
import { IMAGES } from '../utils/constants';
import { scrollToOffer } from '../utils/scroll';
import { MegapackImage } from './MegapackImage';
export function HeroSection() {
  return <section className="pt-28 pb-16 px-4 bg-gradient-to-b from-stone-950 via-zinc-900 to-stone-100 overflow-hidden" data-id="element-103">
      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-104">
        <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 leading-tight" data-id="element-105">
          Trasforma le Tue Lezioni di Tango in un'Esperienza{' '}
          <span className="text-amber-400" data-id="element-106">Coinvolgente</span> che i Tuoi
          Studenti Vorranno Continuare
        </h1>

        <p className="text-xl md:text-2xl text-stone-200 max-w-3xl mx-auto mb-12" data-id="element-107">
          Scopri il sistema pratico e completo che ti aiuta a creare lezioni più
          efficaci, studenti più coinvolti e progressi reali, senza perdere ore
          a improvvisare ogni settimana.
        </p>

        {/* Fan Image Layout */}
        <MegapackImage size="large" className="mb-12" onClick={scrollToOffer} data-id="element-108" />

        <p className="text-stone-600 font-semibold mb-8" data-id="element-109">
          5 Risorse + 4 Bonus Gratuiti
        </p>

        <button onClick={scrollToOffer} className="bg-red-700 hover:bg-red-800 text-white rounded-full py-5 px-10 font-bold text-xl md:text-2xl shadow-[0_0_20px_rgba(185,28,28,0.5)] hover:shadow-[0_0_30px_rgba(250,204,21,0.4)] transition-all animate-pulse-fast" data-id="element-110">
          👉 Accedi Ora al Metodo Completo
        </button>
      </div>
    </section>;
}